import React from 'react';
import siteContent from '../../content/site/content.json';
const challengeData = siteContent.challenge;
import * as Icons from 'lucide-react';
import { AlertTriangle, ArrowRight } from 'lucide-react';

const ChallengeSection = () => {
  const getIcon = (iconName) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent className="w-6 h-6" /> : null;
  };

  return (
    <section id="challenge" className="py-20 lg:py-28 bg-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#FFF8F5] to-transparent" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#B5541B]/10 px-4 py-2 rounded-full mb-6">
            <AlertTriangle className="w-5 h-5 text-[#B5541B]" />
            <span className="text-sm font-semibold text-[#B5541B] uppercase tracking-wide">The Reality</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F1E1E] max-w-3xl mx-auto leading-tight">
            {challengeData.heading}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#3B3535]/70 max-w-2xl mx-auto">
            {challengeData.subheading}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 lg:gap-6 mb-10 max-w-5xl mx-auto">
          {challengeData.challenges.map((challenge, index) => (
            <div
              key={index}
              data-testid={`challenge-card-${index}`}
              className="group bg-white rounded-2xl p-7 border border-gray-100 hover:border-[#B5541B]/30 shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-[#B5541B]/10 flex items-center justify-center text-[#B5541B] mb-5 group-hover:bg-[#B5541B] group-hover:text-white transition-all duration-300">
                {getIcon(challenge.icon)}
              </div>
              <h3 className="text-lg font-bold text-[#1F1E1E] mb-2">
                {challenge.title}
              </h3>
              <p className="text-sm text-[#3B3535]/70 leading-relaxed">
                {challenge.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mb-8">
          <button
            type="button"
            data-testid="challenge-see-how-link"
            onClick={() => {
              const el = document.querySelector('#how-it-works');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#B5541B] hover:text-[#8B3F14] transition-colors group"
          >
            See how ResiAX could help
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </button>
        </div>

        {challengeData.result && (
          <div className="bg-gradient-to-r from-[#B5541B] to-[#8B3F14] rounded-2xl p-8 lg:p-10 text-white text-center shadow-xl">
            <p className="text-lg lg:text-xl font-semibold leading-relaxed max-w-3xl mx-auto">
              {challengeData.result}
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ChallengeSection;
